import { components } from "./components/index";

export function registerAllComponents() {
  components.forEach((component) => component.register());
}
